var audio_default = {
  "fontElementMap": "zUkc9",
  "container": "e7KCM",
  "coverImageContainer": "_-4Db2",
  "customPlayer": "_7-lU7",
  "slim": "GG6BE",
  "playPauseButton": "fewcr",
  "coverImage": "_3Hb9b",
  "trackDetailsContainer": "pWTH7",
  "controlsContainer": "_45SoP",
  "controlsGroup": "_98yOt",
  "sliderContainer": "GxufG",
  "audioDuration": "guYMb",
  "isLoading": "whmWb",
  "audioDetails": "boNEc",
  "authorName": "_4OunV",
  "title": "vODo9",
  "dropdownMenuWrapper": "NwGy2",
  "dropdownSelectedButton": "PMXBx",
  "dropdownContent": "_1kCh9",
  "dropdownContentWithIcon": "MRHvl",
  "audioLoader": "JUd7q"
};
export {
  audio_default as default
};
//# sourceMappingURL=audio-scss.js.map
